import { FC, useState } from 'react';

import { PictureIcon } from '../../../assets';
import { IFlag } from './types';
import { twMerge } from 'tailwind-merge';
import { Skeleton } from '../../skeleton';

export const Flag: FC<IFlag> = ({
  alpha2,
  FallbackIcon,
  className,
  fallbackClassName,
  imageClassName,
  isLoading,
}) => {
  const [isLoadingImage, setIsLoadingImage] = useState(true)
  const [isError, setIsError] = useState(false);

  const setErrorHandler = () => {
    setIsError(true);
  };



  const loadImageHandler = () => {
    setIsLoadingImage(false);
  }

  return (
    <div className={className}>
      {isError || !alpha2 ? (
        (FallbackIcon ?? (
          <PictureIcon className={twMerge('h-full w-full', fallbackClassName)} />
        ))
      ) : (
        <div className='relative h-full w-full'>
          {(isLoading || isLoadingImage) &&
            <div className={twMerge('absolute inset-0 z-1', className)}>
              <Skeleton
                className={twMerge('h-full w-full rounded-full', fallbackClassName)}
              />
            </div>
          }
          <img
            src={`/assets/flags/${String(alpha2 ?? '')}.svg`}
            alt={String(alpha2 ?? '')}
            loading="lazy"
            onError={setErrorHandler}
            onLoad={loadImageHandler}
            className={twMerge('h-full w-full', imageClassName)}

          />
        </div>
      )}
    </div>
  );
};
